import useAuth from "../../utils/CustomHooks/useAuth/useAuth";
import {
  DICTIONARY_CITIES_PUT,
  DICTIONARY_ORGANIZATIONS_PUT,
  DICTIONARY_PORTS_PUT,
  DICTIONARY_VESSELS_PUT,
} from "../axios";

/** Creates trigger function to put (edit) element from dictionary
 * @param {import("axios").AxiosInstance} axios
 * @param {"port" | "vessel" | "organization" | "city"} type
 * @returns {(id: string, body : *) => Promise<void>}
 */

export function useAxiosPutDictionary(axios, type) {
  const { updateRequestDataDictionary } = useAuth();

  const url = (function chooseURL() {
    switch (type) {
      case "port":
        return DICTIONARY_PORTS_PUT;
      case "vessel":
        return DICTIONARY_VESSELS_PUT;
      case "organization":
        return DICTIONARY_ORGANIZATIONS_PUT;
      case "city":
        return DICTIONARY_CITIES_PUT;
      default:
        return undefined;
    }
  })();

  return (id, body) =>
    axios.put(url + id, body).then(updateRequestDataDictionary);
}
